import { render, staticRenderFns } from "./ItemProduto.vue?vue&type=template&id=1209e286&scoped=true"
import script from "./ItemProduto.vue?vue&type=script&lang=js"
export * from "./ItemProduto.vue?vue&type=script&lang=js"
import style0 from "./ItemProduto.vue?vue&type=style&index=0&id=1209e286&prod&lang=scss"
import style1 from "./ItemProduto.vue?vue&type=style&index=1&id=1209e286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1209e286",
  null
  
)

export default component.exports